import Grid from "components/primitives/Grid";

interface PageHeaderActionsProps {
  children?: React.ReactNode;
}

function PageHeaderActions(props: PageHeaderActionsProps) {
  return (
    <Grid container sx={{ alignItems: "center", gap: 1 }}>
      {props.children}
    </Grid>
  );
}

export default PageHeaderActions;
